import { toast } from "react-toastify";

export type SmsResult = {
  attempted?: boolean;
  sent?: boolean;
  message?: string | null;
  type?: "welcome" | "appointment" | "invoice" | "reminder" | string;
};

/** Automated notifications — no UI toast (cron reminders, appointment confirmations). */
const SILENT_SMS_TYPES = new Set(["reminder", "reminder-hour", "appointment"]);

export function showSmsResultToast(sms?: SmsResult | null) {
  if (!sms?.attempted) return;
  if (sms.type && SILENT_SMS_TYPES.has(sms.type)) return;

  if (sms.sent) {
    toast.success(sms.message || "SMS sent successfully");
  } else {
    toast.error(sms.message || "Failed to send SMS");
  }
}

export function notifySmsBalanceChanged() {
  window.dispatchEvent(new CustomEvent("sms-balance-changed"));
}
